export interface Incident {
  channelId: string
  channelName: string
  channelPrivate: boolean
  createdOn: string
  duration: number
  id: number
  identifiedOn
  impact
  incidentStatusId?: IncidentStatus
  mitigatedOn
  name: string
  participants: Participant[]
  resolution
  resolvedOn
  severity?: Severity
  summary
  workspace?: Workspace
}

export interface Participant {
  user: {
    id: string
    realName: string
    avatarUrl: string
    chatUserId: string
  }
  role: {
    id: number
    name: string
    description: string
  }
}

export interface Severity {
  id: number
  name: string
  emoji: string
  description: string
  sortOrder: number
}

export interface Workspace {
  id: number
  name: string
  teamId: string
  appId: string
}

export enum IncidentStatus {
  DECLARED = "DECLARED",
  RESOLVED = "RESOLVED",
}
